'use client'
import React, { useState, useEffect } from 'react'
import ProgressBar from './ProgressBar'

const ClientProgressBar = () => {
  const [progress, setProgress] = useState(0)
  
  useEffect(() => {
    // Function to calculate reading progress
    const calculateReadingProgress = () => {
      // Get scroll position and document height
      const scrollTop = window.scrollY || document.documentElement.scrollTop
      
      // Get the blog content element
      const contentElement = document.querySelector('[data-blog-content]')
      
      if (!contentElement) {
        // Fallback to calculating based on whole document if content element not found
        const scrollHeight = document.documentElement.scrollHeight
        const clientHeight = document.documentElement.clientHeight
        const scrollableHeight = scrollHeight - clientHeight
        
        if (scrollableHeight > 0) {
          const percentage = Math.round((scrollTop / scrollableHeight) * 100)
          setProgress(Math.max(0, Math.min(100, percentage)))
        } else {
          setProgress(100) // If no scroll possible, reading is complete
        }
        return
      }
      
      // Get content position and dimensions
      const contentRect = contentElement.getBoundingClientRect()
      const contentTop = contentRect.top + window.scrollY  // Absolute position
      const contentBottom = contentRect.bottom + window.scrollY
      const contentHeight = contentRect.height
      
      // If we haven't reached content yet
      if (scrollTop < contentTop) {
        setProgress(0)
        return
      }
      
      // If we've scrolled past the content
      if (scrollTop >= contentBottom - window.innerHeight) {
        setProgress(100)
        return
      }
      
      // Calculate progress within content
      const scrollableContentHeight = contentHeight - window.innerHeight
      if (scrollableContentHeight <= 0) {
        setProgress(100) // Content is fully visible
        return
      }
      
      // Calculate how far we've scrolled into the content
      const scrolledInContent = scrollTop - contentTop
      const percentage = Math.round((scrolledInContent / scrollableContentHeight) * 100)
      setProgress(Math.max(0, Math.min(100, percentage)))
    }
    
    // Calculate initial progress
    calculateReadingProgress()
    
    // Add scroll event listener
    window.addEventListener('scroll', calculateReadingProgress)
    window.addEventListener('resize', calculateReadingProgress)
    
    // Clean up
    return () => {
      window.removeEventListener('scroll', calculateReadingProgress)
      window.removeEventListener('resize', calculateReadingProgress)
    }
  }, [])
  
  return <ProgressBar percentage={progress} />
}

export default ClientProgressBar